import styles from '@/assets/js/map/mapStyles'
import pickStyles from '@/assets/js/map/pickMapStyles'
import animate from '@/assets/js/animate'
import { googleSize, googlePoint } from '@/assets/js/map/googleMaps'

const getMarkerSize = marker => marker.icon.scaledSize.width

const markerConfig = (size, config = {}) => ({
  ...config,
  scaledSize: googleSize(size, size),
  size: googleSize(size, size),
  anchor: googlePoint(size / 2, size / 2)
})

const MAP_CENTER = { lat: 52.229899, lng: 21.011815 }
const DEFAULT_ZOOM = 15
const BASE_MARKER_SIZE = 20

const MAP_CONFIG = {
  styles,
  zoom: DEFAULT_ZOOM,
  center: MAP_CENTER,
  disableDefaultUI: true
}

const PICK_MAP_CONFIG = {
  zoom: DEFAULT_ZOOM,
  center: MAP_CENTER,
  styles: pickStyles,
  disableDefaultUI: true,
  backgroundColor: 'none'
}

const MARKER_CONFIG = markerConfig(BASE_MARKER_SIZE, { url: '/img/marker.svg' })
const VIDEO_MARKER_CONFIG = markerConfig(BASE_MARKER_SIZE, { url: '/img/marker-video.svg' })
const PICK_MARKER_CONFIG = markerConfig(BASE_MARKER_SIZE * 1.25, { url: '/img/marker-submit.svg' })

const scaleMarker = (marker, scale = 1) => {
  animate({
    startValue: getMarkerSize(marker),
    endValue: BASE_MARKER_SIZE * scale,
    duration: 300,
    callback: value => marker.setIcon(markerConfig(value, marker.icon))
  })
}

export {
  MAP_CONFIG,
  PICK_MAP_CONFIG,
  MARKER_CONFIG,
  VIDEO_MARKER_CONFIG,
  PICK_MARKER_CONFIG,
  MAP_CENTER,
  DEFAULT_ZOOM,
  BASE_MARKER_SIZE,
  getMarkerSize,
  scaleMarker
}



// WEBPACK FOOTER //
// ./src/assets/js/map/map.js